import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Avatar, Button, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import { darkTheme, lightTheme } from "Common/hooks/StyleFeatures/colors";
const { Text, Paragraph } = Typography;
const WelcomeSection = ({ darkMode, lastLogin, learner, currentCourses }) => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const theme = darkMode ? darkTheme : lightTheme;
  const navigate = useNavigate();
  return (
    <Card
      style={{
        borderRadius: 8,
        marginBottom: 6,
        backgroundColor: theme.background,
        borderColor: theme.border,
        backgroundImage: theme.backgroundGradient,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)'
      }}
      variant="borderless"
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8
      }}>
        <div style={{ flex: 1 }}>
          <Text strong style={{
            color: theme.textPrimary,
            fontSize: 18,
            display: 'block',
            marginBottom: 4,
            lineHeight: 1.4
          }}>
            Welcome back, {learner.firstName} {learner.lastName}!
          </Text>
          <Paragraph style={{
            color: theme.textSecondary,
            marginBottom: 12,
            fontSize: 14
          }}>
            You have {currentCourses} active courses
          </Paragraph>
          <Space>
            <Button
              type="primary"
              size="middle"
              disabled={isBlocked}
              onClick={() => navigate("/training")}
              style={{ background: theme.buttonPrimary, borderColor: theme.buttonPrimaryBorder }}
            >
              View Trainings
            </Button>
            <Button
              size="middle"
              disabled={isBlocked}
              onClick={() => navigate("/training-group")}
              style={{ color: theme.buttonSecondary, borderColor: theme.buttonSecondaryBorder }}
            >
              Training Groups
            </Button>
          </Space>
          <div style={{ marginTop: 8 }}>
            <Text style={{
              color: theme.textTertiary,
              fontSize: 12
            }}>
              Last login: {new Date(lastLogin).toLocaleString()}
            </Text>
          </div>
        </div>
      </div>
    </Card>
  );
};
WelcomeSection.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  lastLogin: PropTypes.string.isRequired,
  learner: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    profileImage: PropTypes.string,
    activeCourses: PropTypes.number,
    learningStats: PropTypes.shape({
      coursesCompleted: PropTypes.number,
      scores: PropTypes.number,
      submittedTasksCount: PropTypes.number
    }),
  }).isRequired,
  currentCourses: PropTypes.number.isRequired,
};
export default WelcomeSection;